/**
 * Formats facet option labels for display. Funnelback often returns facet
 * values lowercased; ucFirst-only styling yields "Carnegie to oakleigh".
 * This applies title-style casing: capitalize words, keep short joiners
 * (to, and, of, …) lowercase in the middle of the phrase.
 */
const SMALL_WORDS = new Set([
    "a",
    "an",
    "the",
    "and",
    "but",
    "or",
    "nor",
    "as",
    "at",
    "by",
    "for",
    "from",
    "in",
    "into",
    "of",
    "on",
    "to",
    "vs",
    "v",
]);

/** Leading/trailing punctuation around an alphanumeric "word" (e.g. "hawthorn,"). */
const WORD_SEGMENT =
    /^([^A-Za-z0-9'-]*)([A-Za-z0-9][A-Za-z0-9'-]*)([^A-Za-z0-9'-]*)$/;

export default function formatFacetValueLabel(input: string): string {
    if (typeof input !== "string" || input.length === 0) {
        return input;
    }

    const tokens = input.split(/(\s+)/);
    const wordIndexes = tokens
        .map((token, i) => (WORD_SEGMENT.test(token.trim()) ? i : -1))
        .filter((i) => i >= 0);

    const firstWord = wordIndexes[0];
    const lastWord = wordIndexes[wordIndexes.length - 1];

    return tokens
        .map((token, i) => {
            if (!/\S/.test(token)) {
                return token;
            }
            const m = token.match(WORD_SEGMENT);
            if (!m) {
                return token;
            }
            const [, lead, core, trail] = m;
            const lower = core.toLowerCase();
            if (i !== firstWord && i !== lastWord && SMALL_WORDS.has(lower)) {
                return `${lead}${lower}${trail}`;
            }
            return `${lead}${
                lower.charAt(0).toUpperCase() + lower.slice(1)
            }${trail}`;
        })
        .join("");
}
